import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAdSponsor } from '../../store/actions/general.actions';
import jwtService from '../../services/jwtService';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NewLoading from '../../Components/Common/NewLoading';

const settings = {
    dots: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 3,
    margin: 10,
    prevArrow: false,
    nextArrow: false,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
    ],
};

const AdSponsor = () => {

    const dispatch = useDispatch();
    const { adSponsorLoading, adSponsorBanner } = useSelector(state => state.general);

    useEffect(() => {
        dispatch(getAdSponsor());
    }, []);

    const handleClick = async (banner_url, redirect_url) => {
        try {
            let response = await jwtService.snedAdSponsorClick(banner_url);
        } catch (error) {

        }
        window.open(redirect_url, '_blank');
    };
    return (
        <>
            {adSponsorLoading ?
                <NewLoading customClass="casino-loader" />
                :
                <>
                    <div className="ad-sponsor-slider">
                        ADS
                    </div >
                    <div className="ad-sponsor-slider">
                        {console.log('adSponsorBanner', adSponsorBanner?.length)}
                        {adSponsorBanner?.length > 0 && <Slider {...settings}>
                            {adSponsorBanner?.length > 0 && adSponsorBanner.map((item) => {
                                return (
                                    <div className='cursor-pointer' key={item?.id} onClick={() => handleClick(item.image_url, item.redirect_url)} >
                                        <img src={item.image_url} alt="promotion-banner" />
                                    </div>
                                );
                            })}
                        </Slider>}
                    </div >
                </>
            }
        </>
    );
};

export default AdSponsor;